/**
 * Do not edit this file it is auto-generated by io-utils / gen-api-models.
 * See https://github.com/pagopa/io-utils
 */
/* eslint-disable  */

import { IbanMaster } from "./IbanMaster";
import * as t from "io-ts";
import { UTCISODateFromString } from "@pagopa/ts-commons/lib/dates";

// required attributes
const IbanR = t.interface({});

// optional attributes
const IbanO = t.partial({
  description: t.string,

  dueDate: UTCISODateFromString,

  fiscalCode: t.string,

  iban: t.string,

  objId: t.Integer,

  validity_date: UTCISODateFromString,

  publication_date: UTCISODateFromString
});
// NOTE: fix-circular-generated-models: patched to break a circular
// import cycle detected among: InformativePaFasce, InformativePaDetail, InformativePaMaster, IbanValidiPerPa, IbanAttributeMaster, Iban, IbanMaster, Pa.
// This block is regenerated automatically by
// scripts/fix-circular-generated-models.js after every `gen-api-models` run
// - do not hand-edit `generated/` files, they are wiped on each generation.
export type Iban = t.TypeOf<typeof IbanR> &
  t.TypeOf<typeof IbanO> & {
  readonly "ibanMasters"?: ReadonlyArray<IbanMaster>;
  };

export const Iban: t.Type<Iban> = t.recursion("Iban", () =>
  t.intersection(
    [IbanR, t.partial({ ...IbanO.props, "ibanMasters": t.readonlyArray(IbanMaster, "array of IbanMaster") })],
    "Iban"
  ) as unknown as t.Type<Iban>
);
